import { i18n } from '/plugins/i18n.client';
import { vuetifyOptions } from '/src/common/config/vuetify.options.js';

export const colorOptions = () => [
  {
    name: i18n.global.t('admin.widgets.edit_widget.default'),
    color: 'Default',
    value: 'default'
  },
  {
    name: i18n.global.t('admin.widgets.edit_widget.standard_color', {
      number: i18n.global.t('admin.widgets.edit_widget.default')
    }),
    color: vuetifyOptions.theme.themes.light.colors.standardDefault,
    value: 'standardDefault'
  },
  {
    name: i18n.global.t('admin.widgets.edit_widget.standard_color', { number: 1 }),
    color: vuetifyOptions.theme.themes.light.colors.standard1,
    value: 'standard1'
  },
  {
    name: i18n.global.t('admin.widgets.edit_widget.standard_color', { number: 2 }),
    color: vuetifyOptions.theme.themes.light.colors.standard2,
    value: 'standard2'
  },
  {
    name: i18n.global.t('admin.widgets.edit_widget.standard_color', { number: 3 }),
    color: vuetifyOptions.theme.themes.light.colors.standard3,
    value: 'standard3'
  },
  {
    name: i18n.global.t('admin.widgets.edit_widget.standard_color', { number: 4 }),
    color: vuetifyOptions.theme.themes.light.colors.standard4,
    value: 'standard4'
  },
  {
    name: i18n.global.t('admin.widgets.edit_widget.standard_color', { number: 5 }),
    color: vuetifyOptions.theme.themes.light.colors.standard5,
    value: 'standard5'
  },
  {
    name: i18n.global.t('admin.widgets.edit_widget.standard_color', { number: 6 }),
    color: vuetifyOptions.theme.themes.light.colors.standard6,
    value: 'standard6'
  },
  {
    name: i18n.global.t('admin.widgets.edit_widget.standard_color', { number: 7 }),
    color: vuetifyOptions.theme.themes.light.colors.standard7,
    value: 'standard7'
  },
  {
    name: i18n.global.t('admin.widgets.edit_widget.standard_color', { number: 8 }),
    color: vuetifyOptions.theme.themes.light.colors.standard8,
    value: 'standard8'
  },
  {
    name: i18n.global.t('admin.widgets.edit_widget.standard_color', { number: 9 }),
    color: vuetifyOptions.theme.themes.light.colors.standard9,
    value: 'standard9'
  },
  {
    name: i18n.global.t('admin.widgets.edit_widget.standard_color', { number: 10 }),
    color: vuetifyOptions.theme.themes.light.colors.standard10,
    value: 'standard10'
  },
  {
    name: i18n.global.t('admin.widgets.edit_widget.standard_color', { number: 11 }),
    color: vuetifyOptions.theme.themes.light.colors.standard11,
    value: 'standard11'
  },
  {
    name: i18n.global.t('admin.widgets.edit_widget.default_alert'),
    color: vuetifyOptions.theme.themes.light.colors.defaultAlert,
    value: 'defaultAlert'
  },
  {
    name: i18n.global.t('admin.widgets.edit_widget.alert_color', { number: 1 }),
    color: vuetifyOptions.theme.themes.light.colors.alert1,
    value: 'alert1'
  },
  {
    name: i18n.global.t('admin.widgets.edit_widget.alert_color', { number: 2 }),
    color: vuetifyOptions.theme.themes.light.colors.alert2,
    value: 'alert2'
  },
  {
    name: i18n.global.t('admin.widgets.edit_widget.alert_color', { number: 3 }),
    color: vuetifyOptions.theme.themes.light.colors.alert3,
    value: 'alert3'
  },
  {
    name: i18n.global.t('admin.widgets.edit_widget.alert_color', { number: 4 }),
    color: vuetifyOptions.theme.themes.light.colors.alert4,
    value: 'alert4'
  },
  {
    name: i18n.global.t('admin.widgets.edit_widget.alert_color', { number: 5 }),
    color: vuetifyOptions.theme.themes.light.colors.alert5,
    value: 'alert5'
  }
];

export const colorsMap = () => ({
  standardDefault: vuetifyOptions.theme.themes.light.colors.standardDefault,
  standard1: vuetifyOptions.theme.themes.light.colors.standard1,
  standard2: vuetifyOptions.theme.themes.light.colors.standard2,
  standard3: vuetifyOptions.theme.themes.light.colors.standard3,
  standard4: vuetifyOptions.theme.themes.light.colors.standard4,
  standard5: vuetifyOptions.theme.themes.light.colors.standard5,
  standard6: vuetifyOptions.theme.themes.light.colors.standard6,
  standard7: vuetifyOptions.theme.themes.light.colors.standard7,
  standard8: vuetifyOptions.theme.themes.light.colors.standard8,
  standard9: vuetifyOptions.theme.themes.light.colors.standard9,
  standard10: vuetifyOptions.theme.themes.light.colors.standard10,
  standard11: vuetifyOptions.theme.themes.light.colors.standard11,
  alertDefault: vuetifyOptions.theme.themes.light.colors.alertDefault,
  alert1: vuetifyOptions.theme.themes.light.colors.alert1,
  alert2: vuetifyOptions.theme.themes.light.colors.alert2,
  alert3: vuetifyOptions.theme.themes.light.colors.alert3,
  alert4: vuetifyOptions.theme.themes.light.colors.alert4,
  alert5: vuetifyOptions.theme.themes.light.colors.alert5
});
